import { isNil } from 'ramda';

import useCompanyUserId from 'common/hooks/useCompanyUserId/useCompanyUserId';

import type { DetailedTransactionFragment } from '../../Sidebar/graphql/fragment/detailedTransaction.gql';

interface TransactionInitiatorNameResult {
  shouldDisplayInitiatorName: boolean;
}

const useTransactionInitiatorName = (
  transaction: Pick<
    DetailedTransactionFragment,
    'initiatorName' | 'companyUserId'
  >,
): TransactionInitiatorNameResult => {
  const { companyUserId: transactionCompanyUserId, initiatorName } =
    transaction;
  const { companyUserId } = useCompanyUserId();
  const shouldDisplayInitiatorName =
    !isNil(companyUserId) &&
    !isNil(initiatorName) &&
    transactionCompanyUserId !== companyUserId;
  return { shouldDisplayInitiatorName };
};

export default useTransactionInitiatorName;
